/**
 * Routes list
 * Worksheet API
 */
let _prefix = '/worksheet/v1'

export default {
  // Анкета в группе
  anketa: _prefix + '/form-data/$id',
  findUser: _prefix + '/find-user',
  template: _prefix + '/anketa-template',
  form: _prefix + '/form',
  active: _prefix + '/active-form',
  archive: _prefix + '/archive-form',
  forms: _prefix + '/forms',
  orgschemeForms: _prefix + '/posts-forms',
  statusFolder: _prefix + '/statuses-folder',
  statusFolders: _prefix + '/statuses-folders',
  status: _prefix + '/status',
  statuses: _prefix + '/statuses',
  statusList: _prefix + '/statuses-list',
  addStatus: _prefix + '/add-one',
  addStatuses: _prefix + '/add-many',
  formStatuses: _prefix + '/form-statuses',
}



// WEBPACK FOOTER //
// ./src/apps/org/api/anketa/routes.js